import * as React from 'react';
import { TslDebugProvider, TslDebugViewer } from './TslDebug';
import Area, { Props as AreaProps } from './Area';

export type Props = AreaProps;

function TslDebugArea(props: Props) {
  const { children, ...rest } = props;

  return (
    <TslDebugProvider>
      <Area {...rest}>{children}</Area>
      <TslDebugViewer showVertexShader showFragmentShader />
    </TslDebugProvider>
  );
}

export default TslDebugArea;
